import { useFormikContext } from 'formik';
import React, { useCallback } from 'react';
import { CustomInfoCard } from './GeneralSettingsFields.styles';
import { CompanySettingsFull } from '../utils/GeneralSettingsUtils';
import useSetGeneralSettingsFields from '../utils/useSetGeneralSettingsFields';
import { useGlobalization } from '@Translations';
import { Checkbox, FormControlLabel } from '@mui/material';
import { getRegionName, useIsFeatureEnabled } from '@innovyze/stylovyze';
import { FLAGS } from '@Types';
export default function Libraries() {
	const { t } = useGlobalization();

	const { values, setFieldValue } = useFormikContext<CompanySettingsFull>();
	const setGeneralSettingsFields = useSetGeneralSettingsFields();

	const handleCanShareTemplatesExternallyChange = useCallback(
		(_, checked) => {
			const canShareTemplateExternally = checked;
			setFieldValue(
				'canShareTemplateExternally',
				canShareTemplateExternally,
			);
			setGeneralSettingsFields({
				canShareTemplateExternally,
			});
		},
		[],
	);
	const region = getRegionName();
	const enableAllRegionTemplateSharing = useIsFeatureEnabled(
		FLAGS.ENABLE_ALL_REGIONS_TEMPLATE_SHARING,
	);

	if (region === 'us-west-2' || enableAllRegionTemplateSharing) {
		return (
			<CustomInfoCard fullHeight title={t('Template')}>
				<FormControlLabel
					control={
						<Checkbox
							data-cy="allowShareTemplates"
							checked={values.canShareTemplateExternally}
							onChange={handleCanShareTemplatesExternallyChange}
						/>
					}
					label={t('Allow users to share templates externally')}
				/>
			</CustomInfoCard>
		);
	} else return null;
}
